import Configurator from '../../../configurator'

const swiperDefaultSettings = {
    slidesPerView: 'auto',
    centeredSlides: false,
    shouldSwiperUpdate: true,
    spaceBetween: 5,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
}

export const swiperCommunitySettings = {
    ...swiperDefaultSettings,
    breakpoints: {
        1199: {
            slidesPerView: 5,
            spaceBetween: 10,
        },
        991: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        767: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
    },
}

export default class SwiperConfigurator extends Configurator {
    paramsEvents = {
        ...swiperDefaultSettings,
        breakpoints: {
            1910: {
                slidesPerView: 6,
                spaceBetween: 10,
            },
            1570: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
            1356: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            1270: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            870: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
        },
    }

    paramsProfileEvents = {
        ...swiperDefaultSettings,
        breakpoints: {
            1199: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            767: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        },
    }

    paramsGroups = {
        ...swiperDefaultSettings,
        breakpoints: {
            1910: {
                slidesPerView: 6,
                spaceBetween: 10,
            },
            1570: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
            1356: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            1270: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            870: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
        },
    }

    paramsNews = {
        ...swiperDefaultSettings,
        breakpoints: {
            1910: {
                slidesPerView: 6,
                spaceBetween: 10,
            },
            1570: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
            1356: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            1270: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            870: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
        },
    }

    paramsProfileGroups = {
        ...swiperDefaultSettings,
        breakpoints: {
            1199: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            767: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        },
    }

    paramsUsers = {
        ...swiperDefaultSettings,
        freeMode: true,
        breakpoints: {
            1366: {
                slidesPerView: 9,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 6,
                spaceBetween: 10,
            },
            640: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
        },
    }

    paramsVenues = {
        ...swiperDefaultSettings,
        breakpoints: {
            1920: {
                slidesPerView: 7,
                spaceBetween: 10,
            },
            1366: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            767: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
        },
    }

    paramsPhotos = {
        ...swiperDefaultSettings,
        spaceBetween: 10,
        slidesPerView: 2,
        breakpoints: {
            1200: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
        },
    }

    paramsBlogGallery = {
        ...swiperDefaultSettings,
        slidesPerView: 2,
    }

    paramsSportnections = {
        containerClass: 'wide-slider swiper-container',
        slidesPerView: 'auto',
        centeredSlides: false,
        shouldSwiperUpdate: true,
        freeMode: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    }

    paramsActionBox = {
        ...swiperDefaultSettings,
        slidesPerView: 2,
        navigation: false,
        containerClass: 'wide-slider progress-slider',
        breakpoints: {
            1200: {
                slidesPerView: 5,
            },
            991: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
        },
    }

    paramsCitySlider = {
        ...swiperDefaultSettings,
        slidesPerView: 1,
        navigation: false,
        speed: 800,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    }

    paramsSmallEvents = {
        ...swiperDefaultSettings,
        spaceBetween: 8,
        slidesPerView: 'auto',
        breakpoints: {
            991: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
        },
    }

    paramsSmallEventsGroups = {
        ...this.paramsSmallEvents,
        breakpoints: {
            991: {
                slidesPerView: 2,
            },
        },
    }

    paramsDetailsMenu = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1183,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                },
            },

        ],
    }

    paramHeaderButtons = {
        ...swiperDefaultSettings,
        containerClass: 'wide-slider p-1',
        navigation: false,
        loop: true,
        spaceBetween: 20,
        breakpoints: {
            1910: {
                slidesPerView: 7,
            },
            1570: {
                slidesPerView: 6,
            },
            1356: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
            1270: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            870: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
        },
    }
}
